// Burger.styled.js
import styled from 'styled-components'
export const StyledBurger = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-self: ${({ alignSelf }) => alignSelf || ''};
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  background: white;

  div {
    width: 2rem;
    height: 0.25rem;
    background:  #fdfdfd;
    border-radius: 10px;
    transition: all 0.3s linear, opacity 0.1s linear;
    transform-origin: 1px;

    :first-child {
      transform: ${({ isOpen }) => isOpen ? 'rotate(45deg)' : 'rotate(0)'};
    }

    :nth-child(2) {
      opacity: ${({ isOpen }) => isOpen ? '0' : '1'};
      transform: ${({ isOpen }) => isOpen ? 'rotate(45deg)' : 'rotate(0)'};
      /*transform: ${({ isOpen }) => isOpen ? 'translateX(20px)' : 'translateX(0)'};*/
    }

    :nth-child(3) {
      transform: ${({ isOpen }) => isOpen ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }
`
